(() => {
  const consentFeatureName = 'consent-tracking-api';

  const installPrivacyFallback = () => {
    const shopify = window.Shopify;
    if (!shopify || typeof shopify.loadFeatures === 'function') {
      return;
    }

    shopify.loadFeatures = (features) => {
      if (!Array.isArray(features)) {
        return;
      }

      features.forEach((feature) => {
        if (feature?.name !== consentFeatureName || typeof feature.onLoad !== 'function') {
          return;
        }

        const customerPrivacy = shopify.customerPrivacy;
        if (customerPrivacy && typeof customerPrivacy.shouldShowGDPRBanner === 'function') {
          feature.onLoad();
        }
      });
    };
  };

  installPrivacyFallback();
  window.addEventListener('load', installPrivacyFallback, { once: true });
})();
